import { Delete as DeleteIcon } from '@mui/icons-material';
import { Box, IconButton, Typography } from '@mui/material';
import React from 'react';
import { Palette } from 'Palette';
import SlidePasteButton from './SlidePasteButton';

/**
 * The hover-reveal row of slide-level actions: the "Slide N" label, the
 * paste-to-replace-image button, and remove. Sits over the slide's image zone.
 */
export default function ImageCarouselSlideControls({
  index,
  onFile,
  onVideoUrl,
  onRemove,
}: {
  index: number;
  onFile: (file: File) => void;
  onVideoUrl?: (url: string) => void;
  onRemove: () => void;
}) {
  return (
    <Box
      className="slide-controls"
      sx={{
        position: 'absolute',
        top: 6,
        right: 6,
        display: 'flex',
        alignItems: 'center',
        gap: 0.5,
        px: 0.5,
        borderRadius: 1,
        bgcolor: 'rgba(255,255,255,0.92)',
        opacity: 0,
        transition: 'opacity 0.12s ease',
      }}
    >
      <Typography variant="caption" sx={{ fontWeight: 600, color: 'text.secondary' }}>
        Slide {index + 1}
      </Typography>
      <SlidePasteButton
        ariaLabel={`Paste image for slide ${index + 1}`}
        onFile={onFile}
        onVideoUrl={onVideoUrl}
      />
      <IconButton
        size="small"
        aria-label={`Remove slide ${index + 1}`}
        onClick={onRemove}
        sx={{ color: Palette.warning.buttonBg }}
      >
        <DeleteIcon fontSize="small" />
      </IconButton>
    </Box>
  );
}
